import React from 'react';
import classNames from 'classnames';
import Image from '@lib/components/Image/Image';
import TextEditor from '@lib/components/TextEditor/TextEditor';
import { hasTextEditorValue } from '@lib/components/TextEditor/utils';
import Typography from '@lib/components/Typography/Typography';
import { colorToChipType } from '@lib/components/Chip/utils/colorEnum';
import NewBadge from '../../NewBadge';
import styles from './AnnouncementWidget.module.scss';

interface AnnouncementWidgetProps {
  title?: string | null;
  description?: string | null;
  // Backend `ColorEnum` (e.g. `BLUE`); rendered via the `chip-*` SCSS class.
  backgroundColor?: string | null;
  imageSrc?: string | null;
  showBadge?: boolean;
}

export default function AnnouncementWidget({
  title,
  description,
  backgroundColor,
  imageSrc,
  showBadge = false,
}: AnnouncementWidgetProps) {
  const containerClassName = classNames(styles.container, {
    [styles[colorToChipType(backgroundColor)]]: backgroundColor,
  });

  return (
    <div className={containerClassName}>
      {showBadge && <NewBadge className={styles.badge} />}
      <div className={styles.scrollWrapper}>
        <div className={styles.content}>
          {imageSrc && (
            <div className={styles.imageWrapper}>
              <Image
                src={imageSrc}
                className={styles.image}
                alt={title || ''}
              />
            </div>
          )}
          <div className={styles.textContent}>
            {title && (
              <Typography variant="h3" className={styles.title}>
                {title}
              </Typography>
            )}
            {hasTextEditorValue(description) && (
              <TextEditor
                readOnly
                useCollapse={false}
                value={description}
                className={styles.description}
              />
            )}
          </div>
        </div>
      </div>
      <div className={styles.gradientOverlay} />
    </div>
  );
}
